import { defineMessages } from "react-intl"

export default defineMessages({
  welcome: {
    id: "app.components.Cookies.Welcome.Title",
  },
  welcomeBody: {
    id: "app.components.Cookies.Welcome.Body",
  },
  settings: {
    id: "app.components.Cookies.Settings.Title",
  },
  settingsBody: {
    id: "app.components.Cookies.Settings.Body",
  },
  essential: {
    id: "app.components.Cookies.Essential.Title",
  },
  essentialBody: {
    id: "app.components.Cookies.Essential.Body",
  },
  tracking: {
    id: "app.components.Cookies.Tracking.Title",
  },
  trackingBody: {
    id: "app.components.Cookies.Tracking.Body",
  },

  buttonRefuse: {
    id: "app.components.Cookies.Buttons.Refuse",
  },
  buttonAccept: {
    id: "app.components.Cookies.Buttons.Accept",
  },
  buttonSettings: {
    id: "app.components.Cookies.Buttons.Settings",
  },
  buttonSave: {
    id: "app.components.Cookies.Buttons.Save",
  },
  buttonOn: {
    id: "app.components.Cookies.Buttons.On",
  },
  buttonOff: {
    id: "app.components.Cookies.Buttons.Off",
  },
})
